import { memo } from "react";
import { Grid, Icon, Input, Popup, Select, Loader } from "semantic-ui-react";
import AddressingType from "../AddressingType";
import { HandleSelectChange } from "../../../../../../../custom-hooks/form/types";
import useSubnetPools from "./useSubnetPools.ts";

type SubnetPoolProps = {
  onChange: HandleSelectChange;
  subnetPool?: string;
  addressingType?: string;
};

const SubnetPools = ({
  onChange,
  subnetPool,
  addressingType,
}: SubnetPoolProps) => {
  const { pools, loading, options } = useSubnetPools(onChange, subnetPool);

  return (
    <>
      <Grid.Column
        textAlign="left"
        width={8}
        className="flex vcenter margin-top-20"
      >
        <h5>
          Subnet Pool
          <Popup
            trigger={
              <Icon
                name="warning circle"
                color="grey"
                size="small"
                className="margin-left-10"
              />
            }
          >
            Choose Subnet Pool
          </Popup>
        </h5>
      </Grid.Column>
      <Grid.Column
        textAlign="left"
        width={8}
        className="flex vcenter margin-top-20"
      >
        {loading ? (
          <div className="loader-wrapper">
            <Loader size="mini" active className="one-liner">
              loading...
            </Loader>
          </div>
        ) : options?.length ? (
          <Select
            icon="chevron circle down"
            className="select-box full"
            placeholder="Choose Subnet Pool"
            name="subnetPool"
            options={options}
            value={subnetPool}
            onChange={onChange}
          />
        ) : (
          <Input disabled={true} value="No subnet pool found!" />
        )}
      </Grid.Column>
      {subnetPool && (
        <AddressingType
          pool={pools.find((pool) => pool.id === subnetPool)!}
          onChange={onChange}
          addressingType={addressingType}
        />
      )}
    </>
  );
};

export default memo(SubnetPools);
